import { c as _c } from "react/compiler-runtime";
import { FormInput, PaymentProcessorEnum, PrimaryButton, getPaymentProcessorTitle } from '@systemeio/ui';
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { razorpayConnect } from 'modules/profile/payment-gateways/integrations/razorpay/api';
import { PaymentRazorpayInterface } from 'modules/profile/payment-gateways/integrations/razorpay/types';
import { getRazorpayHelpPageLink } from 'modules/profile/payment-gateways/integrations/razorpay/utils';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
const defaultValues: PaymentRazorpayInterface = {
  apiKeyId: '',
  apiKeySecret: ''
};
const defaultErrors: PaymentRazorpayInterface = {
  apiKeyId: '',
  apiKeySecret: ''
};
const RazorpayCreateModal = () => {
  const $ = _c(34);
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  let t0;
  if ($[0] !== mutatePaymentIntegrations) {
    t0 = async data => {
      await fetchWithErrors(async () => {
        await razorpayConnect(data);
        await mutatePaymentIntegrations();
      }, setErrors);
    };
    $[0] = mutatePaymentIntegrations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onCreate = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.preventDefault();
      setOpened(true);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.settings.payment_gateways.connect");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <PrimaryButton onClick={t1} className="font-bold">{t2}</PrimaryButton>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("dashboard.settings.payment_gateways.connect_payment_title", {
      payment: getPaymentProcessorTitle(PaymentProcessorEnum.Razorpay)
    });
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpened(false);
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== errors || $[11] !== t) {
    t6 = {
      field: "apiKeyId",
      onRender: (value, onChange) => <FormInput key="razorpay-apiKeyId-create" label={t("dashboard.settings.payment-gateways.api_key_id")} value={value} onChange={e_0 => onChange(e_0.target.value)} error={errors.apiKeyId} />
    };
    $[10] = errors;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== errors || $[14] !== t) {
    t7 = {
      field: "apiKeySecret",
      onRender: (value_0, onChange_0) => <FormInput key="razorpay-apiKeySecret-create" label={t("dashboard.settings.payment-gateways.api_secret_key")} value={value_0} onChange={e_1 => onChange_0(e_1.target.value)} error={errors.apiKeySecret} />
    };
    $[13] = errors;
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = [t6, t7];
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = user?.dashboardLocale;
  let t10;
  if ($[19] !== t9) {
    t10 = getRazorpayHelpPageLink(t9);
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = getPaymentProcessorTitle(PaymentProcessorEnum.Razorpay);
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10) {
    t12 = <HelpCenterLink link={t10} integration={t11} />;
    $[22] = t10;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = ["apiKeyId", "apiKeySecret"];
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== onCreate || $[26] !== opened || $[27] !== t12 || $[28] !== t4 || $[29] !== t8) {
    t14 = <CreateModal fullCaption={t4} opened={opened} onClose={t5} defaultValues={defaultValues} needToast={false} creatable={t8} additionalInfo={t12} onCreate={onCreate} requiredFields={t13} />;
    $[25] = onCreate;
    $[26] = opened;
    $[27] = t12;
    $[28] = t4;
    $[29] = t8;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14 || $[32] !== t3) {
    t15 = <>{t3}{t14}</>;
    $[31] = t14;
    $[32] = t3;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};
export default RazorpayCreateModal;